var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { State, Getter, Mutation, Inject } from 'vue-class-state';
import { throttle } from '../../common/utils';
/**
 * dom状态
 */
export class DomState {
    constructor() {
        this.screenWidth = document.body.clientWidth;
        this.bindEvent();
    }
    get showNum() {
        const { screenWidth } = this;
        if (screenWidth <= 1280) {
            return 3;
        }
        if (screenWidth <= 1549) {
            return 4;
        }
        if (screenWidth <= 1789) {
            return 5;
        }
        return 6;
    }
    /** 宽度最小的情况下 */
    get isMinWidth() {
        return this.showNum === 3;
    }
    bindEvent() {
        window.addEventListener('resize', throttle(() => {
            this.setScreenWidth(document.body.clientWidth);
            // console.log(this.screenWidth, this.showNum)
        }, 50, 120));
    }
    setScreenWidth(width) {
        this.screenWidth = width;
    }
}
__decorate([
    State
], DomState.prototype, "screenWidth", void 0);
__decorate([
    Getter
], DomState.prototype, "showNum", null);
__decorate([
    Getter
], DomState.prototype, "isMinWidth", null);
__decorate([
    Mutation
], DomState.prototype, "setScreenWidth", null);
export const IDomState = Inject('dom');
